/**
 * @note this is used instead of dot-object to prevent
 * having workspaces depend on dot-object since common
 * isn't exported as workspace package (yet).
 */
export const flattenObject = (obj: Record<string, any>, prefix = ''): Record<string, any> => {
    // we need this to handle request object
    const safeObj = JSON.parse(JSON.stringify(obj));

    return Object.entries(safeObj).reduce(
        (acc, [key, value]) => {
            const prefixedKey = prefix ? `${prefix}.${key}` : key;

            if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
                Object.assign(acc, flattenObject(value, prefixedKey));
            } else {
                acc[prefixedKey] = value;
            }

            return acc;
        },
        {} as Record<string, any>,
    );
};
